import { AuthProvider, UserProvider } from "@myosh/myosh-login";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import RoutesComponent from "./Components/routing/RoutesComponent";
import {ToastContainer} from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <UserProvider>
         <RoutesComponent />
        </UserProvider>
      </AuthProvider>
      <ToastContainer position="bottom-right"/>
    </Router>
  );
}

export default App;
